import { MARKETING_INDUSTRY_PAGE_CONTENT_A } from './industry-page-content-a';
import { MARKETING_INDUSTRY_PAGE_CONTENT_B } from './industry-page-content-b';
import { MARKETING_INDUSTRY_PAGE_CONTENT_C } from './industry-page-content-c';
import { MARKETING_INDUSTRY_PAGE_CONTENT_D } from './industry-page-content-d';
import type { MarketingIndustrySlug } from './industry-page-model';
import type { MarketingIndustryPageSource } from './industry-page-content.types';

export const MARKETING_INDUSTRY_PAGE = {
  heroOverline: 'For your Industry',
  heroBrand: 'IMAI for',
  sections: {
    workflow: 'Connected Workflow',
    capabilities: 'Built for the Category',
    systems: 'Your System of Record',
  },
} as const;

export const INDUSTRY_BENEFITS_LABELS: Record<MarketingIndustrySlug, string> = {
  apparel: 'Why IMAI for Apparel',
  footwear: 'Why IMAI for Footwear',
  'bags-accessories': 'Why IMAI for Bags & Accessories',
  eyewear: 'Why IMAI for Eyewear',
  'jewelry-watches': 'Why IMAI for Jewelry & Watches',
  packaging: 'Why IMAI for Packaging',
  furniture: 'Why IMAI for Furniture',
  'beauty-personal-care': 'Why IMAI for Beauty & Personal Care',
  toys: 'Why IMAI for Toys',
  'sporting-goods': 'Why IMAI for Sporting Goods',
};

const MARKETING_INDUSTRY_CONTENT: Record<
  MarketingIndustrySlug,
  MarketingIndustryPageSource
> = {
  ...MARKETING_INDUSTRY_PAGE_CONTENT_A,
  ...MARKETING_INDUSTRY_PAGE_CONTENT_B,
  ...MARKETING_INDUSTRY_PAGE_CONTENT_C,
  ...MARKETING_INDUSTRY_PAGE_CONTENT_D,
};

export function getMarketingIndustryPageContent(
  slug: MarketingIndustrySlug
): MarketingIndustryPageSource {
  return MARKETING_INDUSTRY_CONTENT[slug];
}
